import { Checkbox, Paper, Typography } from "@mui/material";
import { Grid, Stack } from "@mui/material";
import React from "react";
import { tokens } from "../../../store/tokens";

const HeaderCell = ({ children }) => (
  <Typography variant="caption" sx={{ color: tokens.color.inkMuted, fontWeight: 700 }}>
    {children}
  </Typography>
);

const Schedule = (props) => {
  const { userSchedule } = props;
  const rows = Array.isArray(userSchedule) ? userSchedule : [];

  return (
    <Paper
      elevation={0}
      sx={{
        padding: `${tokens.card.padding.md}px`,
        borderRadius: `${tokens.card.radius}px`,
        border: `1px solid ${tokens.color.line}`,
        bgcolor: tokens.color.surface,
      }}
    >
      <Stack spacing={1.5}>
        <Typography variant="subtitle1" sx={{ color: tokens.color.ink }}>
          Open Schedule
        </Typography>

        <Grid
          container
          sx={{ borderBottom: `1px solid ${tokens.color.line}`, pb: 1 }}
        >
          <Grid item xs={2}>
            <HeaderCell> </HeaderCell>
          </Grid>
          <Grid item xs={4}>
            <HeaderCell>Day</HeaderCell>
          </Grid>
          <Grid item xs={3}>
            <HeaderCell>Open</HeaderCell>
          </Grid>
          <Grid item xs={3}>
            <HeaderCell>Close</HeaderCell>
          </Grid>
        </Grid>

        {rows.length === 0 && (
          <Typography variant="body2" sx={{ color: tokens.color.inkFaint }}>
            No schedule set yet.
          </Typography>
        )}

        {/* Field names below (day / open_time / close_time / is_open) are a
            best guess at the API shape — the original component never
            actually read `userSchedule`, it just rendered one static
            "Friday, 2–5pm" row regardless of the data. Rename these to
            match whatever expert_schedule.php actually returns. */}
        {rows.map((item, index) => (
          <Grid
            container
            key={item.id ?? item.day ?? index}
            alignItems="center"
            sx={{
              py: 0.5,
              borderBottom:
                index < rows.length - 1 ? `1px solid ${tokens.color.line}` : "none",
            }}
          >
            <Grid item xs={2}>
              <Checkbox
                size="small"
                checked={Boolean(item.is_open ?? true)}
                disabled
                sx={{ color: tokens.color.teal, "&.Mui-checked": { color: tokens.color.teal } }}
              />
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body2" sx={{ color: tokens.color.ink, fontWeight: 500 }}>
                {item.day ?? item.day_name}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="body2" sx={{ color: tokens.color.inkMuted }}>
                {item.open_time ?? item.open}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="body2" sx={{ color: tokens.color.inkMuted }}>
                {item.close_time ?? item.close}
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Stack>
    </Paper>
  );
};

export default Schedule;
